import { ConfigProvider } from "ant-design-vue"
const { ...other } = ConfigProvider
const YwConfigProvider = {
	...other,
	name: "YwConfigProvider",
};

YwConfigProvider.install = function (Vue) {
	Vue.component(YwConfigProvider.name, ConfigProvider);
 }

export default YwConfigProvider;